import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBag2"><Path d="M7.00018 7H2L2.00254 21H7.00018V7Z" fill="currentColor"/><Path d="M9.00018 21H15.0002V7H9.00018V21Z" fill="currentColor"/><Path d="M22.0024 21H17.0002V7H21.9997L22.0024 21Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M7.00238 3H17.0024V7H15.0024V5H9.00238V7H7.00238V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBag2;
